import { Api } from 'utils';

class QuoteService {

	static admin = {
		get: async (params?: any) => Api.createResponse('admin/quotes',params),
		download: async (params?: any) => Api.createResponse('admin/quotes/download',params),		
	}

	static doctor = {
		get: async (params?: any) => Api.createResponse('doctor/quotes',params),
		getData: async (params?: any) => Api.createResponse('doctor/quotes/data',params),
		create: async (params?: any) => Api.createResponse('doctor/quotes/create',params),
		update: async (params?: any) => Api.createResponse('doctor/quotes/update',params),
		delete: async (params?: any) => Api.createResponse('doctor/quotes/delete',params),
		download: async (params?: any) => Api.createResponse('doctor/quotes/download',params),
		view: async (params?: any) => Api.createResponse('doctor/quotes/view',params),
	}

	static clinic = {
		get: async (params?: any) => Api.createResponse('clinic/quotes',params),
		send: async (params?: any) => Api.createResponse('clinic/quotes/send',params),
		download: async (params?: any) => Api.createResponse('clinic/quotes/download',params),
	}

}

export default QuoteService;